// here we define the types of views we support
export const DEFAULT_VIEW = 'normal';
export const DASHBOARD_VIEW = 'dashboard';
export const FEEDBACK_VIEW = 'feedback';
